import I18n from "i18n-js";

const TestComponent = () => {
  return I18n.t("example");
};

export default TestComponent;
